import { Truck, Building2, MapPin, Award, Handshake } from "lucide-react";
import VibrantSectionHeader from "@/components/shared/VibrantSectionHeader";
import ColorfulStatCard from "@/components/shared/ColorfulStatCard";

const stats = [
  { value: "500+", label: "Vehicles Deployed", icon: Truck, color: "green" as const },
  { value: "50+", label: "Government & Enterprise Clients", icon: Building2, color: "blue" as const },
  { value: "15+", label: "Cities Served", icon: MapPin, color: "gold" as const },
  { value: "10+", label: "International Brands", icon: Handshake, color: "teal" as const },
  { value: "5+", label: "Years of Excellence", icon: Award, color: "purple" as const },
];

const StatsCounter = () => {
  return (
    <section className="py-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-background via-card/50 to-background" />
      <div className="container mx-auto px-6 relative z-10">
        <VibrantSectionHeader
          badge="Our Impact"
          title="Numbers That Matter"
          description="Trusted by organizations across Saudi Arabia for sustainable mobility solutions."
          badgeColor="blue"
        />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
          {stats.map((stat, index) => (
            <ColorfulStatCard
              key={stat.label}
              value={stat.value}
              label={stat.label}
              icon={stat.icon}
              color={stat.color}
              delay={index * 100}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsCounter;
